import envizion from 'envizion'

export function logStyledMessage() {
  envizion({
    title: 'Selfwise',
  })
}
